import * as React from "react";
import styled from "styled-components";
import useProductName from "brand-customization/useProductName";
import { DocumentTitle, PageHeader } from "components/common";
import { Alert } from "components/bootstrap";
const StyledAlert = styled(Alert)`
  margin-top: 15px;
`;
const OpenSearchRequiredPage = () => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Unsupported backend search version" }, /* @__PURE__ */ React.createElement(PageHeader, { title: "Unsupported backend search version" }, /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "danger", className: "tm", title: "Anomaly Detection is disabled" }, /* @__PURE__ */ React.createElement("p", null, "Anomaly Detection is disabled because the ", productName, " server is not using OpenSearch."))));
};
export default OpenSearchRequiredPage;
